<div class="my-google-map">
  <google-map [width]="null" [height]="null" [options]="mapOptions">
    <map-marker *ngFor="let marker of markers" [position]="marker.position" [options]="getMarkerOptions(marker)"
      [title]="marker.title" (mapClick)="markerClickEvent(marker)"></map-marker>
  </google-map>
</div>






<nz-drawer *ngIf="selectedMarker" [nzVisible]="markerDetailsDrawerVisible" [nzWidth]="640" [nzClosable]="false"
  (nzOnClose)="close()" [nzTitle]="selectedMarker.title">
  <ng-container *nzDrawerContent>
    <nz-descriptions [nzColumn]="1">
      <nz-descriptions-item><span class="">{{selectedMarker.news.country?.name_en}}</span> |
        {{selectedMarker.news.published_at | date:'short'}}</nz-descriptions-item>

      <nz-descriptions-item>
        {{selectedMarker.news.description}}
      </nz-descriptions-item>
    </nz-descriptions>
    <nz-divider></nz-divider>
    <nz-descriptions [nzColumn]="1">
      <nz-descriptions-item><img *ngIf="selectedMarker.news.news_images"
          [src]="getPicSource(selectedMarker.news.news_images[0]?.image?.url)" alt="" />
      </nz-descriptions-item>
      <nz-descriptions-item [nzSpan]="2"><span class="fw5">Category : </span>{{selectedMarker.news.category?.name_en}}
      </nz-descriptions-item>
      <nz-descriptions-item *ngIf="selectedMarker.news.external_link" nzTitle="External Link" [nzSpan]="2"><a
          (click)="goToLink(selectedMarker.news.external_link)">External Link</a>
      </nz-descriptions-item>
      <nz-descriptions-item *ngIf="selectedMarker.news.externalLink" nzTitle="External Link" [nzSpan]="2"><a
          (click)="goToUNODCLink(selectedMarker.news.externalLink)">External Link</a>
      </nz-descriptions-item>
    </nz-descriptions>
  </ng-container>
</nz-drawer>